/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.mapStateToProps = exports.name = exports.Price = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'Price';
exports.name = name;

var Price = function Price(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      _classCallCheck(this, _class);

      return _super.call(this, props);
    }

    _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            after = _this$props.after,
            before = _this$props.before,
            classes = _this$props.classes,
            _this$props$price = _this$props.price,
            price = _this$props$price === void 0 ? 0 : _this$props$price;
        return react_1.default.createElement(Frame, {
          className: ['Price__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, react_1.default.createElement(Text, {
          className: ['Price__price', classes === null || classes === void 0 ? void 0 : classes.price]
        }, "$", price.toLocaleString()), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Price = Price;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api,
      app = state.app;
  var configuration = api.configuration;
  var countryCode = app.countryCode;
  var db = new BrightsmithDb(api);
  var model = db.getCurrentModel();
  var price = db.calculateTotalPrice(configuration, model, countryCode);
  return {
    price: price
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _a, _b, _c;

  return {
    container: Object.assign({
      display: 'flex',
      flexDirection: 'column'
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.Price) === null || _a === void 0 ? void 0 : _a.container),
    price: Object.assign({
      color: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.primary,
      fontSize: 28,
      fontWeight: '300'
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.Price) === null || _c === void 0 ? void 0 : _c.price)
  };
};

exports.style = style;